import { TFormRightOwners } from './types';

export function getLicensorValue(
  value: TFormRightOwners[number] & {hidden: boolean},
) {
  return value?.name
  ? { id: value?.qwireTracksRightsOwnerId ?? value.id, name: value.name, hidden: value.hidden }
  : null;
}
